"use client";

import type React from "react";
import { GridPattern } from "@/components/ui/grid-pattern";
import Link from "next/link";

export default function AuthLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background relative overflow-hidden">
      {/* Animated gradient orbs */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-radial from-primary/20 via-transparent to-transparent blur-3xl animate-pulse"
          style={{ animationDuration: "4s" }}
        />
        <div
          className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-radial from-blue-500/15 via-transparent to-transparent blur-3xl animate-pulse"
          style={{ animationDuration: "6s", animationDelay: "1s" }}
        />
        <div
          className="absolute top-1/4 right-1/4 w-1/2 h-1/2 bg-gradient-radial from-violet-500/10 via-transparent to-transparent blur-3xl animate-pulse"
          style={{ animationDuration: "8s", animationDelay: "2s" }}
        />
      </div>

      {/* Grid pattern overlay */}
      <GridPattern width={60} height={60} className="absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] fill-primary/5 stroke-primary/10" />

      {/* Subtle vignette effect */}
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-background/80" />

      {/* Content container */}
      <div className="relative z-10 w-full max-w-md px-4">
        {/* Logo */}
        <Link href="/" className="flex items-center justify-center mb-8 group">
          <div className="relative">
            <div className="absolute inset-0 bg-primary/30 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
        </Link>

        {children}
      </div>
    </div>
  );
}
